class MedicalHistoryLifestyleAndSocial {
    public OccupationalRisks?: boolean;
    public FinancialOrHousingIssues?: boolean;
    public PoorSocialSupport?: boolean;
    public BeliefsOrPracticesAffectingCare?: boolean;
    public RelationshipProblems?: boolean;
    public IntimatePartnerOrFamilyViolence?: boolean;
    public ParentingConcerns?: boolean;
    public Other?: boolean;

    constructor(fields?: Partial<MedicalHistoryLifestyleAndSocial>) {
        Object.assign(this, fields);
    }

    public setEmptyFieldsAsNo(): void {
        this.OccupationalRisks = this.OccupationalRisks || false;
        this.FinancialOrHousingIssues = this.FinancialOrHousingIssues || false;
        this.PoorSocialSupport = this.PoorSocialSupport || false;
        this.BeliefsOrPracticesAffectingCare = this.BeliefsOrPracticesAffectingCare || false;
        this.RelationshipProblems = this.RelationshipProblems || false;
        this.IntimatePartnerOrFamilyViolence = this.IntimatePartnerOrFamilyViolence || false;
        this.ParentingConcerns = this.ParentingConcerns || false;
        this.Other = this.Other || false;
    }
}

export { MedicalHistoryLifestyleAndSocial };
